import { ReactElement } from "react";
interface MyEquipmentLinkContentProps {
  children: ReactElement | ReactElement[];
  classname?: string;
}

export const MyEquipmentLinkContent = ({
  children,
  classname
}: MyEquipmentLinkContentProps) => {
  return (
      <div className={classname}>{children}</div>
  );
};
